import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical EN URL. */
export const Route = createFileRoute("/terms-of-service")({
  beforeLoad: () => {
    throw redirect({ to: "/en/terms", statusCode: 301 });
  },
});
